/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
import { globalScope } from '../constants/runtime';
export function isFileProtocol() {
  var _globalScope$location;

  return Boolean((globalScope === null || globalScope === void 0 ? void 0 : (_globalScope$location = globalScope.location) === null || _globalScope$location === void 0 ? void 0 : _globalScope$location.protocol) === 'file:');
}